import { useSelector } from 'react-redux';

import { getSelectedProperty } from 'entities/Property/model/selectors/PropertySelectors';
import { useFeatureFlag } from 'shared/lib/hooks/useFeatureFlag';

/**
 * In-order savings (order-level and item-level) is shown only when:
 * - Flipt flag `in_order_savings_enabled` is true, and
 * - Property `isInOrderSavingsEnabled` is true (default true when unset).
 */
export const useInOrderSavingsVisible = (): boolean => {
    const inOrderSavingsEnabled = useFeatureFlag('in_order_savings_enabled');
    const selectedProperty = useSelector(getSelectedProperty);
    const isInOrderSavingsEnabled =
        selectedProperty?.isInOrderSavingsEnabled ?? true;

    return inOrderSavingsEnabled === true && isInOrderSavingsEnabled;
};
